import { createAction, handleActions } from 'redux-actions';
import { _getAllDocs } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';
import { _addNewConfigDoc, _deleteConfigDocById, _getAllActiveDocs, _updateConfigDocById } from '../../../shared/httpService/apis';
import { getFormData } from '../../../shared/utils/formData';

const initialState = {
  get_config_docs: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },
  add_config_doc: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  edit_config_doc: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  delete_config_doc: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  active_docs: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
};

export const getConfigDocsStart = createAction(ActionTypes.GET_CONFIG_DOCS);
export const getConfigDocsSuccess = createAction(ActionTypes.GET_CONFIG_DOCS_SUCCESS, response => response);
export const getConfigDocsError = createAction(ActionTypes.GET_CONFIG_DOCS_ERROR, error => error);

export const getAllDocs = (page = '', pageSize = 10) => dispatch => {
  dispatch(getConfigDocsStart());
  return _getAllDocs(page, pageSize)
    .then(response => dispatch(getConfigDocsSuccess(response)))
    .catch((error) => dispatch(getConfigDocsError(error)));
};

export const addNewConfigDocStart = createAction(ActionTypes.ADD_NEW_CONFIG_DOC);
export const addNewConfigDocSuccess = createAction(ActionTypes.ADD_NEW_CONFIG_DOC_SUCCESS, response => response);
export const addNewConfigDocError = createAction(ActionTypes.ADD_NEW_CONFIG_DOC_ERROR, error => error);

export const addNewConfigDoc = (data) => (dispatch) => {
  let formdata = getFormData(data)
  dispatch(addNewConfigDocStart());
  return _addNewConfigDoc(formdata).then((response) => {
    dispatch(addNewConfigDocSuccess(response));
  }).catch((error) => {
    dispatch(addNewConfigDocError(error));
  });
};

export const editConfigDocStart = createAction(ActionTypes.EDIT_CONFIG_DOC);
export const editConfigDocSuccess = createAction(ActionTypes.EDIT_CONFIG_DOC_SUCCESS, response => response);
export const editConfigDocError = createAction(ActionTypes.EDIT_CONFIG_DOC_ERROR, error => error);

export const editConfigDoc = (id, obj) => (dispatch) => {
  let formdata = getFormData(obj)
  dispatch(editConfigDocStart());
  return _updateConfigDocById(id, formdata).then((response) => {
    dispatch(editConfigDocSuccess(response));
  }).catch((error) => {
    dispatch(editConfigDocError(error));
  });
};

export const deleteConfigDocStart = createAction(ActionTypes.DELETE_CONFIG_DOC);
export const deleteConfigDocSuccess = createAction(ActionTypes.DELETE_CONFIG_DOC_SUCCESS, response => response);
export const deleteConfigDocError = createAction(ActionTypes.DELETE_CONFIG_DOC_ERROR, error => error);

export const deleteConfigDoc = (id) => (dispatch) => {
  dispatch(deleteConfigDocStart());
  return _deleteConfigDocById(id).then((response) => {
    dispatch(deleteConfigDocSuccess(response));
  }).catch((error) => {
    dispatch(deleteConfigDocError(error));
  });
};

export const getActiveConfigDocsStart = createAction(ActionTypes.GET_ACTIVE_CONFIG_DOCS);
export const getActiveConfigDocsSuccess = createAction(ActionTypes.GET_ACTIVE_CONFIG_DOCS_SUCCESS, response => response);
export const getActiveConfigDocsError = createAction(ActionTypes.GET_ACTIVE_CONFIG_DOCS_ERROR, error => error);

export const getAllActiveDocs = () => dispatch => {
  dispatch(getActiveConfigDocsStart());
  return _getAllActiveDocs()
    .then(response => dispatch(getActiveConfigDocsSuccess(response)))
    .catch((error) => dispatch(getActiveConfigDocsError(error)));
};

const reducer = handleActions({
  //CONFIG_DOCS_LIST
  [ActionTypes.GET_CONFIG_DOCS]: (state) => ({
    ...state, get_config_docs: {
      ...state.get_config_docs,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_CONFIG_DOCS_SUCCESS]: (state, action) => ({
    ...state,
    get_config_docs: {
      ...state.get_config_docs,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_CONFIG_DOCS_ERROR]: (state, action) => ({
    ...state,
    get_config_docs: {
      ...state.get_config_docs,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //ADD_NEW_CONFIG_DOC
  [ActionTypes.ADD_NEW_CONFIG_DOC]: (state) => ({
    ...state,
    add_config_doc: {
      ...state.add_config_doc,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.ADD_NEW_CONFIG_DOC_SUCCESS]: (state, action) => ({
    ...state,
    add_config_doc: {
      ...state.add_config_doc,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.ADD_NEW_CONFIG_DOC_ERROR]: (state, action) => ({
    ...state,
    add_config_doc: {
      ...state.add_config_doc,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  // //EDIT_CONFIG_DOCS
  [ActionTypes.EDIT_CONFIG_DOC]: (state) => ({
    ...state,
    edit_config_doc: {
      ...state.edit_config_doc,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.EDIT_CONFIG_DOC_SUCCESS]: (state, action) => ({
    ...state,
    edit_config_doc: {
      ...state.edit_config_doc,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_CONFIG_DOC_ERROR]: (state, action) => {
    return ({
      ...state,
      edit_config_doc: {
        ...state.edit_config_doc,
        error: action.payload, loading: false, hasError: true, response: {}
      }
    })
  },
  // //DELETE_CONFIG_DOCS
  [ActionTypes.DELETE_CONFIG_DOC]: (state) => ({
    ...state,
    delete_config_doc: {
      ...state.delete_config_doc,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.DELETE_CONFIG_DOC_SUCCESS]: (state, action) => ({
    ...state,
    delete_config_doc: {
      ...state.delete_config_doc,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.DELETE_CONFIG_DOC_ERROR]: (state, action) => ({
    ...state,
    delete_config_doc: {
      ...state.delete_config_doc,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),

  [ActionTypes.GET_ACTIVE_CONFIG_DOCS]: (state) => ({
    ...state, active_docs: {
      ...state.active_docs,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_CONFIG_DOCS_SUCCESS]: (state, action) => ({
    ...state,
    active_docs: {
      ...state.active_docs,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_CONFIG_DOCS_ERROR]: (state, action) => ({
    ...state,
    active_docs: {
      ...state.active_docs,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
}, initialState);

export default reducer;